import Axios from 'axios';
import {myInfo} from '../services/auth';
import {loginUser, getMyInfo} from '../actions/auth';
import {
    fetchVehicleConfigs,
    fetchJobTypes,
    fetchAgencyCompanies,
    fetchWorkingContexts,
    fetchFavouriteJobIds,
    fetchFavouriteAdIds,
    fetchUserGalleries,
    fetchUserAgencies
} from '../actions/configs';
import {getVehicleAdConfigs, getJobTypes} from '../services/configs';
import {getAgencyCompaniesList, getUserAgencies} from '../services/agency';
import {getGalleryWorkingContexts, getUserGalleries} from '../services/gallery';
import {myFavouriteAdIds, myFavouriteJobIds} from '../services/auth';

export const onLoginServiceCalls = (userToken='') => {
    return (dispatch, getState) => {
        return myInfo({
            header: {
                Authorization: `Token ${userToken}`
            }
        })
        .then((response) => {
            dispatch(loginUser({token: userToken}))
            dispatch(getMyInfo(response.data))
            // return {
            //     success: {
            //         status: response.status,
            //         body: response.data
            //     }
            // }
            const apiCalls = [
                getVehicleAdConfigs({
                    header: {
                        Authorization: `Token ${userToken}`
                    }
                }),
                getJobTypes(),
                getAgencyCompaniesList(),
                getGalleryWorkingContexts(),
                myFavouriteAdIds({
                    header: {
                        Authorization: `Token ${userToken}`
                    }
                }),
                myFavouriteJobIds({
                    header: {
                        Authorization: `Token ${userToken}`
                    }
                }),
                getUserAgencies({
                    header: {
                        Authorization: `Token ${userToken}`
                    }
                }),
                getUserGalleries({
                    header: {
                        Authorization: `Token ${userToken}`
                    }
                })
            ];
            return Axios.all(apiCalls)
                .then(Axios.spread((vehicleConfigs, jobTypes, companyBrands, contextes, adIds, jobIds, userAgencies, userGalleries) => {
                    dispatch(fetchVehicleConfigs(vehicleConfigs.data))
                    dispatch(fetchJobTypes(jobTypes.data))
                    dispatch(fetchAgencyCompanies(companyBrands.data))
                    dispatch(fetchWorkingContexts(contextes.data))
                    dispatch(fetchFavouriteAdIds(adIds.data))
                    dispatch(fetchFavouriteJobIds(jobIds.data))
                    dispatch(fetchUserAgencies(userAgencies.data))
                    dispatch(fetchUserGalleries(userGalleries.data))
                    return {
                        success: {
                            token: userToken
                        }
                    }
                }))
                .catch((error) => {
                    return {
                        error: {
                            token: userToken
                        }
                    }
                })
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            };
        })





        const apiCalls = [
            getVehicleAdConfigs({
                header: {
                    Authorization: `Token ${userToken}`
                }
            })
        ];
        if (userToken){
            apiCalls.push(myInfo({
                header: {
                    Authorization: `Token ${userToken}`
                }
            }));
        }
        console.log("totaly is available", apiCalls.length);
        
        return Axios.all(apiCalls)
        .then(Axios.spread((configs, info) => {
            console.log("HURRRRRRRRRRRRRRRAY")
        }))
        .catch((error) => {
            console.log("OOOOOOOOOOOOOOOOOOOH NOOOOOOOOOOOOOOOOOOOO")
        })
    }
}